import { connect } from "react-redux";
import DocumentLabelsSearchComponent from "./DocumentLabelsSearch";
import {
  addDocumentToSelection,
  removeDocumentFromSelection,
  updateDocumentInSelection,
} from "./state/actions";

const mapStateToProps = (state) => ({
  selectedDocuments: state.documentLabels
    ? state.documentLabels.selectedDocuments
    : [],
});

const mapDispatchToProps = (dispatch) => ({
  addDocumentToSelection: (document) =>
    dispatch(addDocumentToSelection(document)),
  removeDocumentFromSelection: (document) =>
    dispatch(removeDocumentFromSelection(document)),
  updateDocumentInSelection: (document) =>
    dispatch(updateDocumentInSelection(document)),
});

export const DocumentLabelsSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentLabelsSearchComponent);
